import { createContext } from "react"

const JoinContext = createContext({})

export default JoinContext
